(function () {
  var section = document.getElementById('homepage-static-banner');
  if (!section) return;
  var wrapper = section.querySelector('.zoom-media');
  if (!wrapper) return;

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function isEnabled() {
    return window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
  }

  function update() {
    if (!isEnabled()) {
      wrapper.classList.remove('is-zoomed');
      return;
    }

    var rect = section.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;

    // If the section has no height yet (images not loaded), bail and wait for image load
    if (!rect.height) return;

    // Calculate progress between when the section top enters the viewport and when it leaves
    var start = windowHeight; // when top is at bottom of viewport
    var end = -rect.height;   // when bottom passes top
    var progress = 1 - ((rect.top - end) / (start - end));
    progress = Math.max(0, Math.min(1, progress));

    // apply zoom at ~25-80% progress
    if (progress > 0.25 && progress < 0.85) {
      wrapper.classList.add('is-zoomed');
    } else {
      wrapper.classList.remove('is-zoomed');
    }
  }

  // Ensure we recalc once images inside the wrapper have loaded
  var images = Array.prototype.slice.call(wrapper.querySelectorAll('img'));
  function bindImageLoad(img) {
    if (!img) return;
    // If already complete, update once. Otherwise listen for load/error.
    if (img.complete) {
      // schedule async so layout has settled
      setTimeout(update, 0);
    } else {
      img.addEventListener('load', function onload() {
        update();
        img.removeEventListener('load', onload);
      });
      img.addEventListener('error', function onerr() {
        // still run update so we don't hang forever
        update();
        img.removeEventListener('error', onerr);
      });
    }
  }
  images.forEach(bindImageLoad);

  // Observe DOM changes inside the wrapper (Shopify admin may replace the image node)
  var mo = new MutationObserver(function (mutations) {
    var added = false;
    mutations.forEach(function (m) {
      if (m.type === 'childList' && (m.addedNodes && m.addedNodes.length)) added = true;
      if (m.type === 'attributes' && m.attributeName === 'src') added = true;
    });
    if (added) {
      images = Array.prototype.slice.call(wrapper.querySelectorAll('img'));
      images.forEach(bindImageLoad);
      // small delay to allow layout to settle after replacements
      setTimeout(update, 50);
      setTimeout(update, 500);
    }
  });
  mo.observe(wrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', function () {
    update();
  });

  window.addEventListener('orientationchange', update);
  document.addEventListener('visibilitychange', update);

  // initial checks with small delays to catch slow image loads or late HTML injections
  setTimeout(update, 50);
  setTimeout(update, 500);

  // initial call
  update();
})();
